(function (angular) {
    'use strict';

    angular.module('settings')
        /**
         *
         */
        .controller('myProfileCtrl', ['$scope', 'jwtService', 'totpService', 'myProfileData', 'myProfileService', 'growlService', 'uploadFileService', 'sharedDataService','emailDomainValidationService', 'totpStatus',
            function ($scope, jwtService, totpService, myProfileData, myProfileService, growlService, uploadFileService, sharedDataService, emailDomainValidationService, totpStatus) {
            $scope.accountId = jwtService.payload.accountId;
            $scope.userId = jwtService.payload.userId;
            $scope.myProfileData = myProfileData;
            $scope.passwordsData = {};
            $scope.confirmPassword = {};
            $scope.editingTotp = false;
            $scope.idsBag = {
                userId: $scope.userId,
                accountId: $scope.accountId
            }
            $scope.twoFactorAuthData = {
                totpFeatureEnabled: false,
                enabledTotp: false,
                editingTotpValue: false,
            };

            $scope.$on('$viewContentLoaded', function() {
                totpService.isTotpActivated($scope.idsBag).then(function(response) {
                    $scope.twoFactorAuthData.totpFeatureEnabled = response.result;

                    if ($scope.twoFactorAuthData.totpFeatureEnabled) {
                        totpService.getTotpStatus($scope.idsBag).then(function(result) {
                            const currentStatus = totpStatus[result.totpStatus];
                            const isEnabled = currentStatus !== totpStatus.Disabled;

                            $scope.twoFactorAuthData.enabledTotp = isEnabled;
                            $scope.twoFactorAuthData.editingTotpValue = isEnabled;
                        });
                    }
                });
            });

            $scope.editAccount = function () {
                $scope.editingAccount = true;
            };

            $scope.editPassword = function () {
                $scope.editingPassword = true;
            };

            $scope.updateMyProfileData = function () {
                $scope.myProfile = angular.copy($scope.myProfileData);
            };

            $scope.cancelMyProfileUpdate = function () {
                $scope.editingAccount = false;
                $scope.updateMyProfileData();
            };

            $scope.addImage = function () {
                uploadFileService.uploadGlobalFile().then(function (result) {
                    $scope.myProfile.avatarUrl = result.url;
                    myProfileService.updateAvatar($scope.accountId, $scope.userId, $scope.myProfile.avatarUrl).then(function (result) {
                        sharedDataService.setMyProfile($scope.myProfile);
                    });
                });
            };

            $scope.validateEmail = function(email){
                if (emailDomainValidationService.validateEmail(email)) {
                    return true;
                } else {
                    $scope.emailValidationMessage = "This doesn't look like a valid email address";
                    return false;
                }
            };

            $scope.updateMyProfile = function () {
                myProfileService.updateMyProfile($scope.accountId, $scope.userId, $scope.myProfile).then(function (result) {
                    $scope.myProfileData = result;
                    sharedDataService.setMyProfile(result);
                    $scope.editingAccount = false;
                    $scope.updateMyProfileData();
                    growlService.success('Profile correctly updated');
                }).catch(function (error) {
                    $scope.updateMyProfileData();
                    growlService.danger("Profile wasn't update due to: " + error.statusText);
                });
            };

            $scope.cancelPasswordUpdate = function () {
                $scope.passwordsData = {};
                $scope.confirmPassword.value = undefined;
                $scope.editingPassword = false;
            };

            $scope.updatePassword = function () {
                myProfileService.updatePassword($scope.accountId, $scope.userId, $scope.passwordsData).then(function (result) {
                    $scope.passwordsData = {};
                    $scope.confirmPassword.value = undefined;
                    $scope.editingPassword = false;
                    growlService.success('Password correctly changed');
                }).catch(function (error) {

                    growlService.danger("Password wasn't changed due to: " + error.statusText);
                });
            };

            $scope.editTotp = function() {
                $scope.editingTotp = true;
            };


            $scope.saveTwoFactorAuth = function() {
                $scope.editingTotp = false;
                $scope.twoFactorAuthData.enabledTotp = $scope.twoFactorAuthData.editingTotpValue;

                totpService.updateTotpStatus($scope.idsBag, $scope.twoFactorAuthData.enabledTotp ? totpStatus.Enrolling : totpStatus.Disabled);
            };

            $scope.cancelTwoFactorAuth = function() {
                $scope.editingTotp = false;
                $scope.twoFactorAuthData.editingTotpValue = $scope.twoFactorAuthData.enabledTotp;
            };


            $scope.validatePassword = function () {
                if ($scope.passwordsData.newPassword) {
                    if ($scope.passwordsData.newPassword.length >= 8) {
                        if ($scope.passwordsData.newPassword.toLowerCase() != $scope.passwordsData.newPassword && $scope.passwordsData.newPassword.toUpperCase() != $scope.passwordsData.newPassword) {
                            if ($scope.passwordsData.newPassword.match(/\d+/g) !== null) {
                                if (/^[a-zA-Z0-9- ]*$/.test($scope.passwordsData.newPassword)) {
                                    $scope.passwordValidationMessage = "Password should contain at least one special char";
                                }
                                else {
                                    return false;
                                }
                            }
                            else {
                                $scope.passwordValidationMessage = "Password should contain at least one number";
                            }
                        }
                        else {
                            $scope.passwordValidationMessage = "Password should contain at least one capital and one lower case letter";
                        }
                    }
                    else {
                        $scope.passwordValidationMessage = "Password should be at least 8 characters long";
                    }
                    return true;
                }
                return false;
            };

            $scope.updateMyProfileData();

        }]);
})(window.angular);